export interface IFinancialStatementImportOptions {
    importBalanceAndIncomeSeparately: boolean;
    selectAnnualReportForUploadAndMappingAutoFill: boolean;
}
